import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  data: [],
  errorMessage: '',
  searchValue: null
};

const targetAnswersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.TARGET_ANSWERS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case REDUX_ACTIONS.TARGET_ANSWERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.targetAnswers],
        errorMessage: '',
      };
    case REDUX_ACTIONS.TARGET_ANSWERS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: [],
      };
    case REDUX_ACTIONS.TARGET_ANSWERS_SEARCH_CONTROL:
      return {
        ...state,
        searchValue: action.payload.searchValue,
      };
    default:
      return state;
  }
};

export default targetAnswersReducer;
